import { render, staticRenderFns } from "./CellRendererDescription.vue?vue&type=template&id=4edef8dd&"
import script from "./CellRendererDescription.vue?vue&type=script&lang=js&"
export * from "./CellRendererDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports